<template>
  <!-- Campo con modo edicion (input/select siempre visible) o reposo (texto), como el diseno de S03.
       Las fechas usan un selector nativo (type=date) y se muestran en formato DD/MM/AAAA. -->
  <span class="ef" :class="{ dense, bold, money: suffix, 'ef-auto': width !== '100%' }">
    <template v-if="editing">
      <select v-if="type === 'select'" class="ef-in" :style="{ width }" :value="value == null ? '' : value" @change="$emit('save', $event.target.value)">
        <option value=""></option>
        <option v-for="o in options" :key="o.value" :value="o.value">{{ o.label }}</option>
      </select>
      <input v-else-if="type === 'date'" class="ef-in" type="date" :style="{ width }" :value="toISO(value)"
             @change="$emit('save', fromISO($event.target.value))">
      <!-- Dinero: input + simbolo de la moneda a la derecha (como en otros tabs). -->
      <span v-else-if="suffix" class="ef-money">
        <input class="ef-in" type="text" :style="{ width }" :value="value == null ? '' : value" :placeholder="placeholder"
               @change="$emit('save', $event.target.value)">
        <span class="ef-suffix">{{ suffix }}</span>
      </span>
      <input v-else class="ef-in" type="text" :style="{ width }" :value="value == null ? '' : value" :placeholder="placeholder"
             @change="$emit('save', $event.target.value)">
    </template>
    <span v-else class="ef-val" :class="[valClass, { empty: isEmpty }]">{{ display }}</span>
  </span>
</template>

<script>
  export default {
    name: 'PrmEditField',

    props: {
      editing: { type: Boolean, default: false },
      value: { type: [String, Number], default: '' },
      type: { type: String, default: 'text' }, // text | date | number | select
      options: { type: Array, default: null },
      placeholder: { type: String, default: '' },
      format: { type: Function, default: null }, // formateo de solo lectura (moneda, simbolo, %...)
      valClass: { type: [String, Array], default: '' },
      width: { type: String, default: '100%' }, // ancho fijo del input (segun diseno)
      dense: { type: Boolean, default: false }, // 10px (tablas)
      bold: { type: Boolean, default: false }, // seminegrita (titulos/detalle)
      suffix: { type: String, default: '' }, // simbolo de moneda a la derecha del input
    },

    computed: {
      isEmpty () { return this.value === '' || this.value === null || this.value === undefined },
      // Cuando esta vacio mostramos el placeholder como texto guia (no un guion).
      display () {
        if (this.isEmpty) return this.placeholder || ''
        if (this.type === 'select' && this.options) {
          const o = this.options.find((x) => String(x.value) === String(this.value))
          return o ? o.label : this.value
        }
        if (this.type === 'date') return this.fromISO(this.value)
        return this.format ? this.format(this.value) : this.value
      },
    },

    methods: {
      // DD/MM/AAAA -> AAAA-MM-DD (valor del input nativo). Si ya viene ISO lo respeta.
      toISO (v) {
        const m = /^(\d{1,2})[/\-.](\d{1,2})[/\-.](\d{2,4})$/.exec(String(v || '').trim())
        if (!m) return /^\d{4}-\d{2}-\d{2}$/.test(v) ? v : ''
        let y = m[3]
        if (y.length === 2) y = '20' + y
        return `${y}-${m[2].padStart(2, '0')}-${m[1].padStart(2, '0')}`
      },
      // AAAA-MM-DD -> DD/MM/AAAA (lo que persistimos y mostramos). Si no es ISO lo devuelve tal cual.
      fromISO (v) {
        const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(v || ''))
        return m ? `${m[3]}/${m[2]}/${m[1]}` : v
      },
    },
  }
</script>

<style lang="scss" scoped>
  .ef { display: inline-flex; align-items: center; min-width: 0; width: 100%; }
  .ef-in {
    width: 100%; font-size: 11px; font-weight: 400; color: #1f2837; border: 1px solid #d8dde4; border-radius: 4px;
    padding: 3px 6px; height: 24px; box-sizing: border-box; outline: none; background: transparent;
  }
  .ef-in:focus { border-color: #3a6bc8; box-shadow: 0 0 0 2px rgba(58, 107, 200, .12); background: #fff; }
  .ef-in::placeholder { color: #9aa4b2; }
  input[type="date"].ef-in { min-width: 120px; }
  select.ef-in { cursor: pointer; }
  .ef-val { font-size: 11px; color: #1f2837; }
  .ef-val.empty { color: #9aa4b2; font-weight: 400; } // texto guia cuando no hay valor
  .ef.dense .ef-in, .ef.dense .ef-val { font-size: 10px; }
  .ef.bold .ef-in, .ef.bold .ef-val { font-weight: 600; }
  // Ancho fijo (o dinero): el contenedor se ajusta al contenido para que la celda (izq/centro/der) lo alinee.
  // Nota: NO usar el nombre de clase 'fixed' (colisiona con la utilidad global de Tailwind position:fixed).
  .ef.ef-auto, .ef.money { width: auto; }
  .ef-money { display: inline-flex; align-items: center; gap: 4px; }
  .ef-suffix { font-size: 11px; font-weight: 600; color: #5a7896; flex-shrink: 0; }
  .ef.dense .ef-suffix { font-size: 10px; }
</style>
